import * as React from 'react'
import {
  AppBar, Box, Container, IconButton, Link, Menu, MenuItem, Toolbar
} from '@mui/material'
import { NavLink } from 'react-router-dom'
import { MENU_BAR_URLS, WWW_BASE_URL } from '../../../App'
import LogoutComponent from '../../auth/components/LogoutComponent'

import MenuIcon from '@mui/icons-material/Menu'

const ResponsiveMenuAppBar: React.FC = () => {
  const menuItemPaddingTop = 3

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null)

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorElNav(event.currentTarget)
  }

  const handleCloseNavMenu = (): void => {
    setAnchorElNav(null)
  }

  return (
    <Box>
      {/* <AppBar position="static" color={'transparent'}> */}
      <AppBar position="static">
        <Container maxWidth={'lg'} sx={{ px: 0 }}>
          <Toolbar disableGutters>

            {/* ================================================================================================== */}
            {/* Mobile menu */}
            {/* ================================================================================================== */}

            <Box sx={{ display: { xs: 'flex', md: 'none' }, width: '100%' }} justifyContent={'space-between'}>
              <Box sx={{ flexGrow: 0, display: 'flex' }} alignItems={'bottom'} >
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                >
                  <MenuIcon/>
                </IconButton>

                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  keepMounted
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                >
                  {MENU_BAR_URLS.map((page) => (
                    page.internalLink
                      ? (
                        <MenuItem key={page.id} onClick={handleCloseNavMenu}>
                          <Link component={NavLink} to={page.url}
                            // color={'primary.contrastText'}
                                underline={'hover'}
                                variant={'body2'}
                                sx={{ px: 2, textTransform: 'uppercase' }}>
                            { /* pt 4 is to push down the links to they align with logo */}
                            {page.title}
                          </Link>
                        </MenuItem>
                        )
                      : (
                        <MenuItem key={page.id} onClick={handleCloseNavMenu}>
                          <Link href={page.url}
                            // color={'primary.contrastText'}
                                underline={'hover'}
                                variant={'body2'}
                                sx={{ px: 2, textTransform: 'uppercase' }}>
                            {page.title}
                          </Link>
                        </MenuItem>
                        )
                  ))}

                </Menu>
              </Box>

              <Link href={WWW_BASE_URL}>
                <Box component={'img'} sx={{ py: 2, width: 140, flexGrow: 0 }}
                     className="brand-logo" src="/icons/Sun-Exchange-White-Logo.svg" alt="Sun Exchange Logo"/>
              </Link>

              <LogoutComponent paddingTop={menuItemPaddingTop - 2}/>

            </Box>

            {/* ================================================================================================== */}
            {/* Desktop menu */}
            {/* ================================================================================================== */}

            <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', width: '100%' }}>

              <Link href={WWW_BASE_URL}>
                <Box component={'img'} sx={{ py: 2, width: 240 }}
                     className="brand-logo" src="/icons/Sun-Exchange-White-Logo.svg" alt="Sun Exchange Logo"/>
              </Link>

              <Box sx={{ flexGrow: 1 }}>&nbsp;</Box>

              <Box sx={{ flexGrow: 0, pt: menuItemPaddingTop }}>
                {MENU_BAR_URLS.map((page) => (
                  page.internalLink
                    ? (
                      <Link component={NavLink} to={page.url} key={page.id}
                            color={'primary.contrastText'}
                            underline={'hover'}
                            variant={'body2'}
                            sx={{ px: 2, textTransform: 'uppercase' }}>
                        { /* pt 4 is to push down the links to they align with logo */}
                        {page.title}
                      </Link>
                      )
                    : (
                      <Link href={page.url} key={page.id}
                            color={'primary.contrastText'}
                            underline={'hover'}
                            variant={'body2'}
                            sx={{ px: 2, textTransform: 'uppercase' }}>
                        {page.title}
                      </Link>
                      )
                ))}
              </Box>

              <LogoutComponent paddingTop={menuItemPaddingTop}/>

            </Box>

          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  )
}

export default ResponsiveMenuAppBar
